import { useState } from 'react';
import { CustomDialog } from '@/components/dialog/v1/CustomDialog';
import { useLinkCategoryContextValueHook } from '@/views/mypage/contexts/LinkCategoryContextProvider';
import { ModuleCard } from '../weget-module-card/ModuleCard';
import { WegetVideoModuleForm, youtubeThumbnail } from './WegetVideoModuleForm';

/**
 * 에디터 목록의 영상 모듈 카드
 */
export function WegetVideoModuleItem({ moduleItemIndex, moduleItem, clickLog, onReqDelete, onReqChangeIsHide, onReqUpdateInfo }) {
    const linkCategoryContextValueHook = useLinkCategoryContextValueHook();
    const [editOpen, setEditOpen] = useState(false);

    const video = moduleItem?.videoConfig;
    const category = linkCategoryContextValueHook?.content?.find(r => r.id === moduleItem?.linkCategoryId)?.name;

    const handleSubmit = (body) => {
        onReqUpdateInfo({ id: moduleItem?.id, ...body });
        setEditOpen(false);
    }

    return (
        <>
            <ModuleCard
                id={moduleItem.id}
                index={moduleItemIndex}
                isHide={moduleItem?.isHide}
                badgeIcon='/assets/icons/video_default_mainColor.svg'
                badgeLabel='영상'
                badgeExtra={<span className="text-[12px] text-gray-500">유튜브{video?.isShorts ? ' 쇼츠' : ''}</span>}
                categoryName={category}
                onEdit={() => setEditOpen(true)}
                onToggleHide={onReqChangeIsHide}
                onDelete={onReqDelete}
            >
                <div className="flex items-center gap-3">
                    {video?.videoId &&
                        <span className={`relative shrink-0 overflow-hidden rounded-lg bg-gray-900 ring-1 ring-black/5 ${video.isShorts ? 'h-20 w-12' : 'h-14 w-24'}`}>
                            <img src={youtubeThumbnail(video.videoId)} alt="" className="h-full w-full object-cover" />
                            <span className="absolute inset-0 flex items-center justify-center text-[11px] text-white drop-shadow">▶</span>
                        </span>
                    }
                    <div className="min-w-0">
                        <p className="truncate text-[15px] font-bold text-gray-900">{moduleItem?.title || <span className="font-normal text-gray-400">제목 없음</span>}</p>
                        <p className="truncate text-[12px] text-gray-500">{moduleItem?.linkUrl}</p>
                        <p className="mt-1 text-[12px] font-semibold text-gray-600">재생 {clickLog?.totalClickCount || 0}</p>
                    </div>
                </div>
            </ModuleCard>

            {editOpen &&
                <CustomDialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth='sm'>
                    <div className="p-5">
                        <CustomDialog.Header style={{ marginBottom: '20px' }}>
                            <CustomDialog.Header.Fake />
                            <CustomDialog.Header.Title>영상 모듈</CustomDialog.Header.Title>
                            <CustomDialog.Header.Close onClick={() => setEditOpen(false)} />
                        </CustomDialog.Header>
                        <WegetVideoModuleForm initial={moduleItem} submitLabel="수정" onSubmit={handleSubmit} />
                    </div>
                </CustomDialog>
            }
        </>
    );
}
